module.exports = __webpack_public_path__ + "static/media/amazingBet.85af6448.jpeg";